var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ico_comico",class:_vm.$isEn?'ico_pocket':''},[_vm._v("코미코 오리지널")])}
var staticRenderFns = []

export { render, staticRenderFns }